import React from 'react';
import SectionCard from './SectionCard';
import { Checkbox } from '../../ui/checkbox';
import { Switch } from '../../ui/switch';
import ReadonlyField from './ReadonlyField';

const SendLaterSection = ({ submission, jsonContent, isDark }) => {
    if (!(submission.send_later || jsonContent.send_later == 'true')) {
        return null;
    }

    return (
        <SectionCard isDark={isDark}>
            <div className="flex items-center gap-[8px]">
                <Checkbox
                    id="send-later"
                    checked={submission.send_later || jsonContent.send_later || false}
                    labelClassName="cursor-default"
                    isDark={isDark}
                />
                <span className={`text-[16px] font-semibold transition-colors duration-200 ${
                    isDark ? 'text-white' : 'text-[#072837]'
                }`}>
                    Send Later
                </span>
            </div>

            {/* Scheduled Time Display */}
            {(submission.scheduled_time || jsonContent.scheduled_time) && (
                <ReadonlyField
                    value={
                        submission.scheduled_time
                        ? new Date(submission.scheduled_time).toLocaleString('en-AU', { timeZone: 'Australia/Sydney' })
                        : jsonContent.scheduled_time
                        ? new Date(jsonContent.scheduled_time).toLocaleString('en-AU', { timeZone: 'Australia/Sydney' })
                        : ''
                    }
                    placeholder="Scheduled date & time"
                    isDark={isDark}
                />
            )}

            {/* Notify Submitter Toggle */}
            <div className={`border-none rounded-[8px] p-[12px] flex items-center justify-between w-full transition-colors duration-200 ${
                isDark ? 'bg-[#161515]' : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa]'
            }`}>
                <div className="flex gap-[16px] grow items-center">
                    <p className={`font-medium text-[16px] grow leading-normal m-0 transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>
                        Get notified when the scheduled submission is processed
                    </p>
                    <Switch
                        checked={submission.notify_submitter}
                        disabled={true}
                    />
                </div>
            </div>
        </SectionCard>
    );
};

export default SendLaterSection;
